import { useDelete, useGet, usePost, usePut } from "../common/fetchServices";
import { API_BASE_URL } from "../props";
import { notBlank } from "../util/ext";
import { pickBy } from "ramda";
import querystring from "querystring";

const LIMIT = 10;

const getSubscriptionUrl = ({ id }) => `${API_BASE_URL}/subscriptions/${id}`;

const getDateString = date => {
  if (notBlank(date)) {
    const jsDate = new Date(date);
    const year = jsDate.getFullYear();
    const month = ("0" + (jsDate.getMonth() + 1)).slice(-2);
    const day = ("0" + jsDate.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  } else {
    return null;
  }
};

const getSubscriptionsUrl = (
  organization,
  module,
  includeIndirect,
  activeOnly,
  perpetualOnly,
  types,
  expiresBefore,
  orderBy,
  offset,
  limit,
) => {
  const params = pickBy((val, _key) => notBlank(val), {
    "include-indirect": includeIndirect,
    "expires-before": getDateString(expiresBefore),
    "include-expired": !activeOnly,
    "perpetual-only": perpetualOnly,
    module,
    types,
    sort: orderBy,
    offset,
    limit,
  });

  const queryParams = querystring.encode(params);

  if (notBlank(organization)) {
    return `${API_BASE_URL}/organizations/${organization}/subscriptions?${queryParams}`;
  } else {
    return `${API_BASE_URL}/subscriptions?${queryParams}`;
  }
};

export const useSubscriptions = (
  organization,
  module,
  includeIndirect,
  activeOnly,
  perpetualOnly,
  types,
  expiresBefore,
  orderBy,
  page,
  limit = LIMIT,
) => {
  const offset = limit === "all" ? 0 : page * limit;
  const url = getSubscriptionsUrl(
    organization,
    module,
    includeIndirect,
    activeOnly,
    perpetualOnly,
    types,
    expiresBefore,
    orderBy,
    offset,
    limit,
  );

  return useGet(["subscriptions", { url }], url);
};

export const useAllModules = () => {
  const url = `${API_BASE_URL}/admin/modules?limit=all`;
  return useGet(["modules-all"], url);
};

export const useSubscriptionCreate = () => {
  return usePost(() => `${API_BASE_URL}/subscriptions`, {
    queriesToInvalidate: ["subscriptions"],
  });
};

export const useSubscriptionUpdate = () => {
  return usePut(getSubscriptionUrl, {
    queriesToInvalidate: ["subscriptions"],
  });
};

export const useSubscriptionDelete = () => {
  return useDelete(getSubscriptionUrl, {
    queriesToInvalidate: ["authentications", "subscriptions"],
  });
};

export const useCurationCreate = () => {
  return usePost(() => `${API_BASE_URL}/curations/from-module`);
};
